const PLACEHOLDER = "/placeholder.jpg";

/**
 * Public URL for a subcategory hero image. Uses encodeURIComponent for slug so paths match
 * filenames like `men's-clothing.jpg`. If slug is missing, returns placeholder — never
 * `/.../.jpg` (which breaks `next/image` and spams server TimeoutError).
 */
export function getSubCategoryImageSrc(slug) {
  if (slug == null) return PLACEHOLDER;
  const s = String(slug).trim();
  if (s === "") return PLACEHOLDER;
  return `/assets/Sub-Category%20Images/${encodeURIComponent(s)}.jpg`;
}

/**
 * Last line of defense for `next/image`: blocks empty slug paths (encoded or not) and any
 * `/.jpg` basename. Use as `src={sanitizeSubCategoryImageSrc(url)}` when src may come from
 * props, cache, or older bundles.
 */
export function sanitizeSubCategoryImageSrc(src) {
  if (src == null) return PLACEHOLDER;
  const raw = String(src).trim();
  if (!raw) return PLACEHOLDER;
  const pathOnly = raw.split("?")[0];
  if (/\/\.jpe?g$/i.test(pathOnly)) return PLACEHOLDER;
  if (
    /(?:Sub-Category%20Images|Sub-Category Images)\/\.jpe?g$/i.test(pathOnly)
  ) {
    return PLACEHOLDER;
  }
  return raw;
}
